import React from 'react';
import { Link } from 'react-router-dom';
import { Star, CheckCircle, AlertCircle } from 'lucide-react';

export const ProductConditionPolicy = () => {
  return (
    <div className="min-h-screen py-16 bg-[#F9F8F6]" data-testid="product-condition-page">
      <div className="container-custom max-w-4xl">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4" data-testid="condition-title">Product Condition Policy</h1>
          <p className="text-lg text-softgrey">All items are carefully inspected and graded before listing.</p>
        </div>

        <div className="space-y-10">
          <section data-testid="grading-section">
            <h2 className="text-2xl font-heading font-bold mb-6">Condition Grading</h2>
            <div className="space-y-4">
              <div className="bg-cream p-6 rounded-xl border-l-4 border-green-500 flex items-start gap-4" data-testid="grade-excellent">
                <Star className="w-6 h-6 text-green-600 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-bold text-lg mb-1">Excellent</h3>
                  <p className="text-softgrey">Minimal to no visible wear. Item is in near-new condition with no notable flaws.</p>
                </div>
              </div>
              <div className="bg-cream p-6 rounded-xl border-l-4 border-mustard flex items-start gap-4" data-testid="grade-very-good">
                <CheckCircle className="w-6 h-6 text-mustard mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-bold text-lg mb-1">Very Good</h3>
                  <p className="text-softgrey">Light wear consistent with age. May have minor signs of use but overall in great shape.</p>
                </div>
              </div>
              <div className="bg-cream p-6 rounded-xl border-l-4 border-coral flex items-start gap-4" data-testid="grade-good">
                <AlertCircle className="w-6 h-6 text-coral mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-bold text-lg mb-1">Good</h3>
                  <p className="text-softgrey">Visible wear but still very wearable. Character marks that add to the vintage appeal.</p>
                </div>
              </div>
            </div>
          </section>

          <section data-testid="flaws-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Transparency</h2>
            <p className="text-softgrey leading-relaxed">All flaws are shown in images. Any imperfections, marks, or signs of wear are clearly photographed and described in the product listing so you know exactly what you're getting.</p>
          </section>
        </div>

        <div className="mt-16 border-t border-border pt-8">
          <p className="text-softgrey text-sm">Questions about a specific item's condition? <Link to="/contact" className="text-coral hover:underline font-semibold">Contact Us</Link> and we'll be happy to provide more details.</p>
        </div>
      </div>
    </div>
  );
};
